// extracted by mini-css-extract-plugin
export default {"container":"tO","productarea":"uO","btn":"vO","promowrapper":"wO","upsellarea":"xO","subtitle":"yO","system":"zO","desc":"AO","cardswrap":"BO","cards":"CO","squareloadingcontainer":"EO","squareloading33":"FO"};
    if(module.hot) {
      // 1713361652827
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  